import { render, staticRenderFns } from "./hometownAtlasDetail.vue?vue&type=template&id=464029d3&scoped=true&"
import script from "./hometownAtlasDetail.vue?vue&type=script&lang=js&"
export * from "./hometownAtlasDetail.vue?vue&type=script&lang=js&"
import style0 from "./hometownAtlasDetail.vue?vue&type=style&index=0&id=464029d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464029d3",
  null
  
)

export default component.exports